export const SHOPPING_CART_SET_USER_DATA = 'SHOPPING_CART_SET_USER_DATA';
